module.exports = __webpack_public_path__ + "img/logo_xx.adf8997b.png";